import { Text } from '@cleartax/wg-library-typography';
import { trackAction } from '../../../../../../utils';

export const ListSuffix: React.FC<{
  searchInputValue: string;
  noResults?: boolean;
}> = ({ searchInputValue, noResults = false }) => {
  return (
    <>
      {noResults ? (
        <Text
          mergeClasses="override"
          className="w-full h-32 p-10 flex items-center justify-center font-medium text-grey-600 text-s-12 border-grey-300 border-x border-b sm:border-0"
        >
          <Text
            type="span"
            className="icon-info mr-2 mt-1 text-grey-600 block w-1/12"
          ></Text>
          Currently there are no search results available for this query, please
          click below to see more.
        </Text>
      ) : null}
      <Text
        type="a"
        mergeClasses="override"
        href={`/services/search/${searchInputValue}`}
        onClick={() => {
          trackAction('click', '', {
            label: `search_see_more_${searchInputValue}`,
          });
        }}
        className="py-3 font-bold cursor-pointer text-center block w-full text-brand-700 border-t-0 border-sm border-grey-300 rounded-b-lg sm:text-base sm:border-0"
      >
        See more
        <Text
          type="span"
          weight="medium"
          className="icon-arrow_back rotate-180 inline-block pb-0.5 pr-2"
        ></Text>
      </Text>
    </>
  );
};
